import React, { useState, useEffect } from "react";
import { filtersTechnician } from "../../interpreter/technician";
import { getAllSubcription, getAllSubcriptionAll } from "../../interpreter/subcription";
import { FaSearch, FaFilter } from "react-icons/fa";

const TechnicianFilter = ({ setTechnicians, setLoading, getAllTechnicians }) => {
    const [searchData, setSearchData] = useState({
        full_name: "",
        code_sub: "",
    });

    const [subscriptions, setSubscriptions] = useState([]);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            const data = await getAllSubcriptionAll();
            const subs = (data || []).filter((sub) => sub.codeSubcription !== "PARTNER");
            setSubscriptions(subs);
        };
        fetchSubscriptions();
    }, []);

    const handleInputChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
    };

    const handleSearch = async () => {
        setLoading?.(true);
        try {
            const filters = {
                searchParameter: searchData.full_name.trim() || "",
                code_sub: searchData.code_sub || ""
            };

            let data;
            if (!filters.searchParameter && !filters.code_sub) {
                data = await getAllTechnicians();
            } else {
                data = await filtersTechnician(filters);
            }

            const list = Array.isArray(data?.technicians)
                ? data.technicians
                : Array.isArray(data)
                  ? data
                  : [];
            setTechnicians(list);
        } catch (error) {
            console.error("Error al obtener técnicos:", error);
            setTechnicians([]);
        } finally {
            setLoading?.(false);
        }
    };

    return (
        <div className="bg-white p-4 shadow-md rounded-lg mb-4 w-full">
            <h3 className="text-lg font-semibold mb-2 text-left">Buscador</h3>

            {/* 🔹 Diseño con flex para alinear los elementos */}
            <div className="flex items-center gap-2">
                {/* 🔹 Input de búsqueda (ocupa el espacio restante) */}
                <input
                    type="text"
                    name="full_name"
                    placeholder="Buscar por nombre..."
                    value={searchData.full_name}
                    onChange={handleInputChange}
                    className="border p-2 rounded h-10 flex-grow text-sm sm:text-base"
                />

                {/* 🔹 Botón de Filtros */}
                <button
                    onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                    className="flex items-center justify-center h-10 w-10 bg-gray-200 hover:bg-gray-300 rounded"
                >
                    <FaFilter className="text-black" size={15} />
                </button>

                {/* 🔹 Botón de Buscar */}
                <button
                    onClick={handleSearch}
                    className="bg-blue-600 text-white rounded hover:bg-blue-500 flex items-center justify-center h-10 w-10"
                >
                    <FaSearch size={15} />
                </button>
            </div>

            {/* 🔹 Filtros Avanzados (Suscripciones) */}
            {showAdvancedFilters && (
                <div className="mt-3">
                    <select
                        name="code_sub"
                        value={searchData.code_sub}
                        onChange={handleInputChange}
                        className="border p-2 rounded w-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    >
                        <option value="">Selecciona una suscripción</option>
                        {subscriptions.map((sub) => (
                            <option key={sub.id} value={sub.codeSubcription}>
                                {sub.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default TechnicianFilter;